import { TenantSubFeatureModel } from '@utmost.co/enterprise-models';
import { IConfigItem } from '../../types';

export type ClientSupportLink = {
  uid: string;
  title: string;
  url: string;
};

export const mapLinkToItem = (link: ClientSupportLink) =>
  ({ id: link.uid, label: link.url, translatedId: link.title }) as IConfigItem<any, string>;

export const mapItemToLink = (item: IConfigItem<any, string> | undefined) =>
  item ? ({ uid: item.id, url: item.label, title: item.translatedId } as ClientSupportLink) : undefined;

export const mapOrderedFeatureToItem = (item: TenantSubFeatureModel) => {
  return {
    id: item.name,
    translatedId: item.config.label,
    label: item.config.url,
    enabled: item.enabled
  } as IConfigItem<any, string>;
};

export const mapOrderedFeaturesToLinks = (data: any[] | undefined): ClientSupportLink[] => {
  const items: IConfigItem<any, string>[] = mapOrderedFeaturesToItems(data);
  const links: ClientSupportLink[] = items
    .map(mapItemToLink)
    .filter((link) => link !== undefined) as ClientSupportLink[];
  return links;
};

export const mapOrderedFeaturesToItems = (data: any[] | undefined): IConfigItem<any, string>[] => {
  return data?.map(mapOrderedFeatureToItem) ?? [];
};

export const mapItemsToOrderedFeatures = (links: IConfigItem<any, string>[]): TenantSubFeatureModel[] => {
  return links.map((item) => {
    return {
      name: item.id,
      enabled: true,
      label: item.label,
      config: { label: item.translatedId, url: item.label },
      orderedFeatures: []
    } as TenantSubFeatureModel;
  });
};
